import accordFA from './fa/fa.json'

const AccordMessages = {
  fa: { ...accordFA },
}

export default AccordMessages
